﻿export class NavBar {
    public navBar: JQuery;
    public container: JQuery;
    public collapse: JQuery;
    public navLinksLeft: JQuery;
    public navLinksRight: JQuery;
    public navLinksCustom: JQuery;

    constructor() {
        this.navBar = $('<nav class="navbar navbar-default navbar-fixed-top"></nav>');
        this.container = $(`
            <div class="container">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                </button>
                <a class="navbar-brand" href="#"><img alt="Brand" class="midi_common_navbar-shell" src="images/shell.png"/></a>
                <a class="navbar-brand midi_common_main-title" href="#">` + branding.siteName + `</a>
            </div>
            </div>`).appendTo(this.navBar);
        this.collapse = $('<div id="navbar" class="collapse navbar-collapse"></div>')
            .appendTo(this.container);
        this.navLinksLeft = $('<ul class="nav navbar-nav"></ul>')
            .appendTo(this.collapse);
        this.navLinksRight = $('<ul class="nav navbar-nav navbar-right"></ul>')
            .appendTo(this.collapse);
        this.navLinksCustom = $('<ul class="nav navbar-nav navbar-right"></ul>')
            .appendTo(this.collapse);

    }
}